import { createRoot } from 'react-dom/client';
import mapboxgl from 'mapbox-gl';
import FlowmapPopup from '../components/FlowmapPopup';
import s from '../components/FlowmapPopup.module.scss';

export const createFlowmapPopup = (
    map,
    coordinates,
    properties,
    { persistent = false } = {}
) => {
    const el = document.createElement('div');
    const root = createRoot(el);
    root.render(<FlowmapPopup properties={properties} />);

    const popup = new mapboxgl.Popup({
        className: persistent
            ? `${s.FlowmapPopupWrapper} ${s.FlowmapPopupPersistent}`
            : s.FlowmapPopupWrapper,
        offset: 5,
        closeButton: false,
        closeOnClick: false,
        anchor: 'bottom',
        // Mapbox focuses a popup on open by default, which on a hover popup drags
        // the keyboard across the page behind a reader passing over the flows.
        focusAfterOpen: persistent,
    })
        .setLngLat(coordinates)
        .setDOMContent(el)
        .addTo(map);

    // Add persistent flag to popup for identification
    popup._persistent = persistent;

    // The React root has to go with the popup, or hovering the flowmap leaves one
    // mounted root behind per flow passed over.
    const removePopup = popup.remove.bind(popup);
    popup.remove = () => {
        removePopup();
        root.unmount();
        return popup;
    };

    return popup;
};
